import React, { Component } from "react";
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import _ from 'lodash';
import * as wActs from "../actions/website-actions";
import isMobile from 'react-device-detect';
import URL from 'url-parse';
import * as wConst from "../consts/website-consts";
import {getSubdomain} from "../actions/website-actions";
import {setCookie} from "../actions/website-actions";

class ProfileItem extends Component {

  decodeEntities(str) {
    return str.replace(/&#(\d+);/g, function(match, dec) {
      return String.fromCharCode(dec);
    });
  }
  setMarkup() {
    let markup = "";
    let showList = false;
    showList = this.props.Website.Settings.ShowListViews.filter((t) => {return t == "List"}).length>0;

    if(!showList) { return {__html: ""}}
    if(this.props.Profile.Text !== "" && typeof this.props.Profile.Text !== "undefined") {
      markup = _.truncate(this.decodeEntities(this.props.Profile.Text),{length: 200});
    }
    return {__html: markup};
  }

  handleLoad(e) {
    //console.log("In Event")
    let url = e.target.getAttribute('real-img');
    let img = new Image();
    img.onload = () => {
      //console.log("Got Image")
      this.myImg.src = img.src;
    }
    img.src = url;
  }

  getTranslation(key) {
    return this.props.Website.Translations[key];
  }
  getTranslationAndReplace(key, rKey, rVal) {
    let tRep = this.props.Website.Translations[key];
    return tRep.replace(rKey,rVal);

  }


  handleSendMessage(e,props) {

    let location = {
      City: {Name: ""},
      Country: {Code: "",Name: ""}
    }
    if(props.Profile.Location && props.Profile.Location.City) {
      location = props.Profile.Location;
    }
    let msgObj = {
      MessageType: "SMS", Id: props.Profile.Id, Name: props.Profile.EscortName, Image: props.Profile.Image, Location: location, Slogan: props.Profile.Slogan
    };
    props.dispatch(wActs.ShowSendProfileMessage(msgObj));
  }

  backLoadImage() {
    let img = new Image();
    img.onload = () => {
      try {
        this.myImg.src = this.myImg.getAttribute("real-img");
      } catch(ex) {}
    }
    try {
      img.src = this.myImg.getAttribute("real-img");
    } catch(ex1) {}
  }

  componentDidMount() {
    this.eCnt = 0;
    this.imgInt =
    setInterval(()=> {
      try {
        if(this.myImg.complete) {
          clearInterval(this.imgInt);
          this.backLoadImage();
        }
      } catch(ex) {
        this.eCnt++;
        if(this.eCnt>20) {
          clearInterval(this.imgInt);
        }
      }
    },100);
  }


  render() {
    let pSlog = null;
    let cCity = "";
    if (this.props.Profile.Slogan !== "") {
      pSlog = <p style={{ marginBottom: "2px" }}>“ {this.props.Profile.Slogan} ”</p>;
    }
    if (this.props.Profile.Location.City && this.props.Profile.Location.City.Name !== "dontshow" && this.props.Profile.Location.City.Name !== "") {
      cCity = this.props.Profile.Location.City.Name;
    }
    let url = new URL(this.props.Profile.Url);
    let path = url.pathname;
    let ageStr = this.props.Profile.Age;
    if(wActs.isNullOrEmpty(ageStr)) {
      ageStr = "0";
    }
    let age = parseInt(ageStr) < 18 ? "" : this.props.Profile.Age;
    const pro = this.props.Profile;




    return (
      <div className="col-sm-2">
        <Link to={path} title={this.props.Website.Page.AltText.replace("{{Name}}",this.props.Profile.EscortName)} className="model-container">
          <div className="model-image" style={{backgroundImage: `url(${this.props.Image})`}}></div>
          <div className="model-info-block">
            <div className="m-name_description">
              <div className="model-name">
                {!this.props.Website.Settings.ShowTitleInProfileList &&
                  <React.Fragment>
                    <div className="city">{pro.Location.City.Name}</div>
                    <div className="name">{pro.EscortName}</div>
                  </React.Fragment>
                }
                {this.props.Website.Settings.ShowTitleInProfileList &&
                  <React.Fragment>
                    <div className="name">{pro.Title}</div>
                  </React.Fragment>
                }
              </div>
              <div className="model-description" dangerouslySetInnerHTML={this.setMarkup()}></div>
            </div>
            <div className="model-info">
              <ul>
                {!wActs.isNullOrEmpty(age) &&
                <li>
                  <span>{this.getTranslation("page.profile.age")}</span>
                  <span>{age}</span>
                </li>
                }
                {!wActs.isNullOrEmpty(pro.Nationality) &&
                <li>
                  <span>{this.getTranslation("page.profile.nationality")}</span>
                  <span>{pro.Nationality}</span>
                </li>
                }
                {!wActs.isNullOrEmpty(pro.Orientation) && !this.props.Profile.SoonOnTour &&
                <li>
                  <span>{this.getTranslation("page.profile.sexualorientation")}</span>
                  <span>{pro.Orientation}</span>
                </li>
                }
                {this.props.Profile.SoonOnTour &&
                <li><span>{this.getTranslationAndReplace("page.profile.soonin","{{Location}}",cCity)}</span></li>
                }
              </ul>
            </div>
          </div>
        </Link>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    Website: state.Website
  };
}

export default connect(mapStateToProps)(ProfileItem);
